<div class="player-music relative"
    [ngStyle]="{'background-color': settingsData.bg_tertiary_color ? settingsData.bg_tertiary_color : null }"
    [hidden]="!selected_music.activeMusicIndex && selected_music.activeMusicIndex != 0">
    <div class="media-player row no-gutters align-items-center">
        <div class="col-6 col-lg-3 d-none d-md-inline">
            <span class="w-50 d-inline-block"> <img src="{{selected_music?.stream_info?.video_thumbnail_image}}"
                    class="thumb-img"></span>
            <span class="ellipsis w-50 align-middle d-inline-block"
                [ngStyle]="{'color': settingsData.font_secondary_color ? settingsData.font_secondary_color : null }">
                {{selected_music?.stream_info?.stage}} </span>
        </div>
        <div class="col-4 d-inline-block d-md-none d-lg-none">
            <span class="ellipsis align-middle d-inline-block w-100"
                [ngStyle]="{'color': settingsData.font_secondary_color ? settingsData.font_secondary_color : null }">
                {{selected_music?.stream_info?.stage}} </span>
        </div>
        <div class="col-8 col-md-6 col-lg-6 text-center">
            <div style="display: inline-flex;">
                <i class="fa fa-exchange player-icon pt-6" aria-hidden="true" (click)="keepRepeat()" matTooltip="Repeat"
                    matTooltipPosition="above"
                    [ngStyle]="{'color': is_repeat ? settingsData.bg_primary_color : settingsData.font_secondary_color }"></i>
                <i class="fa fa-step-backward player-icon pt-6" aria-hidden="true" (click)="prevAudio()"
                    [ngClass]="{'disabled-area': !canplayPrev() }" matTooltip="Previous Music"
                    matTooltipPosition="above"
                    [ngStyle]="{'color': settingsData.font_secondary_color ? settingsData.font_secondary_color : null }"></i>
                <div class="media-ply-stop-btn top-0 pointer" (click)="playStopAudio('play','UI')"
                    *ngIf="!selected_music?.playing">
                    <i class="fa fa-play player-icon play-icon" aria-hidden="true" matTooltip="Play"
                        matTooltipPosition="above"
                        [ngStyle]="{'color': settingsData.font_secondary_color ? settingsData.font_secondary_color : null }"></i>
                </div>
                <div class="media-ply-stop-btn top-0 pointer" (click)="playStopAudio('pause','UI')"
                    *ngIf="selected_music?.playing">
                    <i class="fa fa-pause player-icon stop-icon" aria-hidden="true" matTooltip="Pause"
                        matTooltipPosition="above"
                        [ngStyle]="{'color': settingsData.font_secondary_color ? settingsData.font_secondary_color : null }"></i>
                </div>
                <i class="fa fa-step-forward player-icon pt-6" aria-hidden="true" matTooltip="Next Music"
                    matTooltipPosition="above" [ngClass]="{'disabled-area': !canplayNext() }" (click)="nextAudio()"
                    [ngStyle]="{'color': settingsData.font_secondary_color ? settingsData.font_secondary_color : null }"></i>
                <i class="fa fa-random player-icon pt-6" aria-hidden="true" (click)="keepShuffle()" matTooltip="Shuffle"
                    matTooltipPosition="above"
                    [ngStyle]="{'color': is_shuffle ? settingsData.bg_primary_color : settingsData.font_secondary_color }"></i>
                <figure style="display: none;">
                    <audio id="audio_1" controls controlsList="nodownload"
                        src="{{selected_music?.stream_info?.video_url_secure}}">
                        Your browser does not support the
                        <code>audio</code> element.
                    </audio>
                </figure>
            </div>
            <div class="d-none d-lg-block">
                <div class="row align-items-center">
                    <!-- <span class="d-none"> {{getAudioTime()}} </span> -->
                    <div class="col-2"
                        [ngStyle]="{'color': settingsData.font_secondary_color ? settingsData.font_secondary_color : null }">
                        {{currentPlayerTime}} </div>
                    <div class="music-progress col-8 p-0">
                        <div class="progress-bar-color" id="progressBarColor"
                            [ngStyle]="{'background-color': settingsData.bg_secondary_color ? settingsData.bg_secondary_color : null }">
                        </div>
                    </div>
                    <div class="col-2"
                        [ngStyle]="{'color': settingsData.font_secondary_color ? settingsData.font_secondary_color : null }">
                        {{totalPlayerTime}} </div>
                </div>
            </div>

        </div>
        <div class="col-lg-3 d-none d-lg-block text-right custom-slider">
            <i class="fa fa-volume-off player-icon" aria-hidden="true" *ngIf="audioVolume == 0"
                (click)="muteUnmutePlayerAudio('unmute')" matTooltip="Unmute" matTooltipPosition="above"
                [ngStyle]="{'color': settingsData.font_secondary_color ? settingsData.font_secondary_color : null }"></i>
            <i class="fa fa-volume-up player-icon" aria-hidden="true" *ngIf="audioVolume != 0"
                (click)="muteUnmutePlayerAudio('mute')" matTooltip="Mute" matTooltipPosition="above"
                [ngStyle]="{'color': settingsData.font_secondary_color ? settingsData.font_secondary_color : null }"></i>

            <mat-slider min="0" max="1" step="0.1" [(ngModel)]="audioVolume" (input)="volumeSliderSliding($event)"
                (change)="volumeSliderChanged($event)">
                <input matSliderThumb [value]="audioVolume" />
            </mat-slider>
              

        </div>
        <div class="w-100 d-lg-none">
            <!-- <div class="music-progress pt-2">
                <div class="progress-bar-color" id="progressBarColor"
                    [ngStyle]="{'background-color': settingsData.bg_secondary_color ? settingsData.bg_secondary_color : null }">
                </div>
            </div> -->
        </div>
    </div>
</div>
<div class="full-page-ad text-center" [hidden]="!showAd" style="">
    <div class="ablum-ads" data-closable>
        <div [innerHTML]="adVideo" alt=' ' title=' ' class="ad bg-dark" *ngIf="showAd"></div>
        <div class="a mb-2" *ngIf="showTimer && showAd">
            <a class="text-center" *ngIf="!router.url.includes('/preview')" [href]="selectedAdData" target="_blank"
                class="mr-2 text-white text-decoration-none">Learn more <i
                    class="fa fa-external-link fs-9 ml-1"></i></a>
            <a class="text-center" *ngIf="router.url.includes('/preview')"
                class="mr-2 text-white text-decoration-none slick-disabled">Learn more <i
                    class="fa fa-external-link fs-9 ml-1"></i></a>
        </div>
        <button class="close-button" aria-label="Close alert" type="button" data-close *ngIf="showTimer && showAd"
            (click)="closeAdd()">

            <span aria-hidden="true">{{seconds_data}}<span class="ml-1"><i
                        class="fa fa-step-forward"></i></span></span></button>
    </div>
</div>